// Module
var code = `talentExpertSourcingProductivityComponent`;
// Exports
export default code;